{
  "NTServiceForms": {
    "fields": {
      "otherReasonForAssistance": {
        "neuropsychiatricOrOtherCognitiveImpairment": "Neuropsykiatrinen tai muu kognitiivinen toimintarajoite"
      }
    }
  }
}
